<template>
  <a-spin :tip="loadingTip" :spinning="isloading">
    <div>
      <div class>
        <a-form :form="form" @submit="handleSubmit">
          <a-form-item
            label="友情链接编号"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
            v-if="this.infos.id"
          >
            <a-input
              placeholder="请输入友情链接编号"
              v-decorator="[
          'id',
          {rules: [{ required: false, message: '请输入友情链接编号!' }],initialValue:info.id}
        ]"
              readonly
            ></a-input>
          </a-form-item>
          <a-form-item label="友情链接名称" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入友情链接名称"
              v-decorator="[
          'name',
          {rules: [{ required: true, message: '请输入友情链接名称!' }],initialValue:info.name}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="友情链接类型"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
          >
            <a-select
              v-decorator="[
          'type',
          {rules: [{ required: true, message: '请选择类型!' }],initialValue:info.type}
        ]"
            >
              <a-select-option value="友情链接">友情链接</a-select-option>
              <a-select-option value="合作院校">合作院校</a-select-option>
            </a-select>
          </a-form-item>
          <a-form-item label="友情链接网址" :label-col="{ span: 5 }" :wrapper-col="{ span: 19 }">
            <a-input
              placeholder="请输入友情链接网址"
              v-decorator="[
          'link',
          {rules: [{ required: true, message: '请输入友情链接网址!' }],initialValue:info.link}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="友情链接排序号"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
          >
            <a-input
              placeholder="请输入友情链接排序号"
              v-decorator="[
          'sortNumber',
          {rules: [{ required: true, message: '请输入友情链接排序号!' }],initialValue:info.sortNumber}
        ]"
            ></a-input>
          </a-form-item>
          <a-form-item
            label="logo图片"
            :label-col="{ span: 5 }"
            :wrapper-col="{ span: 19 }"
           
          >
            <a-upload
              :action="$api.file.uploadFile"
              listType="picture-card"
              :beforeUpload="beforeUpload"
              :fileList="fileList"
              @preview="handlePreview"
              @change="handleChange"
            >
              <div v-if="fileList.length < 1">
                <a-icon type="plus" />
                <div class="ant-upload-text">Upload</div>
              </div>
            </a-upload>
            <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
              <img alt="example" style="width: 100%" :src="previewImage" />
            </a-modal>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 19, offset: 5 }">
            <pxkeji-btn name="保存" type="primary" htmlType="submit" />
            <pxkeji-btn name="取消" type="default" @click="cancelClick" class="cancelBtn" />
          </a-form-item>
        </a-form>
      </div>
    </div>
  </a-spin>
</template>

<script>
var that;
export default {
  props: {
    infos: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      info: {
        status: true,
        sortNumber:0
      },
      isloading: false,
      loadingTip: "加载中...",
      fileList: [],
      cateDatas: [],
      previewVisible: false,
      previewImage: "",
      uploadImg: []
    };
  },
  components: {},
  mounted() {
    this.$nextTick(function() {
      that = this;
      //console.log(this.infos.id);
      // if (this.infos.id) {
      //   //编辑
      //   this.getInfo();
      // }
      this.getCateList();
    });
  },
  methods: {
    /**取消 */
    cancelClick() {
      this.$emit("callbackMethod");
    },
    /**数据回显 */
    getInfo() {
      this.isloading = true;
      this.$api.friendlink
        .getById(this.infos.id)
        .then(res => {
          this.isloading = false;
          if (res.errorCode == this.$msg.responseCode.success) {
            this.info = res.data;

            this.info.status = this.$commen.changeIntBoolean(res.data.status);

            var pics = res.data.logo.split(",");
            for (var i = 0; i < pics.length; i++) {
              this.fileList.push({
                uid: i,
                name: "广告" + (i + 1) + ".png",
                status: "done",
                url: pics[i]
              });
            }
          } else {
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
        });
    },

    handleSubmit(e) {
      e.preventDefault();
      this.form.validateFields((err, values) => {
        if (!err) {
          // if (this.fileList.length == 0) {
          //   this.$message.error("请上传图片");
          //   return false;
          // }

          this.uploadImg = [];
          for (var i = 0; i < this.fileList.length; i++) {
            if (this.fileList[i].url) {
              this.uploadImg.push(this.fileList[i].url);
            } else {
              this.uploadImg.push(this.fileList[i].response.data.path);
            }
          }

           //console.log("form", values);
          // console.log("imgs", this.uploadImg);

          if (that.infos.id) {
            //编辑
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.friendlink
              .updateById(
                that.infos.id,
                values.name,
                values.link,
                values.type,
                this.uploadImg.join(","),
                values.sortNumber
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          } else {
            //新增
            this.isloading = true;
            this.loadingTip = "保存中...";
            this.$api.friendlink
              .add(
                values.name,
                values.link,
                values.type,
                this.uploadImg.join(","),
                values.sortNumber
              )
              .then(res => {
                this.isloading = false;
                if (res.errorCode == this.$msg.responseCode.success) {
                  this.$message.success(res.errorMsg);
                  this.$emit("callbackMethod");
                } else {
                  this.error(res.errorMsg);
                }
              })
              .catch(() => {
                this.isloading = false;
              });
          }
        }
      });
    },
    handleCancel() {
      this.previewVisible = false;
    },
    beforeUpload(file, fileList) {
      var isJPGPNG = false;
      if (file.type === "image/jpeg" || file.type === "image/png") {
        isJPGPNG = true;
      } else {
        isJPGPNG = false;
        this.$message.error("只能上传jpg/png格式的文件!");
      }
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("文件不能超过2MB!");
      }
      return isJPGPNG && isLt2M;
    },
    handlePreview(file) {
      this.previewImage = file.url || file.thumbUrl;
      this.previewVisible = true;
    },
    handleChange(info) {
      if (info.file.status) {
        this.fileList = info.fileList;
      }
    },
    onRangeChange(value, dateString) {
      this.info.validatetimeBegin = dateString[0];
      this.info.validatetimeEnd = dateString[1];
    },
    onCheckboxChange(e) {
      this.info.checked = e.target.checked;
    },
    getCateList() {
      this.isloading = true;
      this.$api.adzone
        .getAll()
        .then(res => {
          this.isloading = false;
          //console.log("分类选择", res);
          if (res.errorCode == this.$msg.responseCode.success) {
            this.cateDatas = res.data;
            // for (var i = 0; i < res.data.length; i++) {

            // }

            // if (this.id) {
            //   this.info = this.cInfo;
            //   this.info.status = this.cInfo.status == 1 ? true : false;
            // }
            if (this.infos.id) {
              //编辑
              this.getInfo();
            }
          } else {
            //this.$message.error(res.errorMsg);
            this.error(res.errorMsg);
          }
        })
        .catch(() => {
          this.isloading = false;
          this.error();
        });
    },
    error(msg) {
      this.$error({
        title: "提示",
        content: msg == undefined ? "服务器异常" : msg,
        okText: "返回",
        centered: true,
        onOk() {
          that.$emit("callbackMethod");
        }
      });
    }
  }
};
</script>
<style>
.anticon-plus-circle {
  margin-left: 10px !important;
  cursor: pointer;
}
.anticon-minus-circle {
  margin-left: 10px !important;
  cursor: pointer;
}
</style>